import PAButton from "component/design-system/buttons/PAButton";
import DropdownButton from "component/react-bootstrap/DropdownButton";
import MenuItem from "component/react-bootstrap/MenuItem";
import { IOrderedItemView } from "interfaces/session/ShoppingCart";
import { useTranslation } from "next-i18next";
import { useState, useEffect } from "react";
import SelectDropdown from "../select-dropdown/SelectDropdown";
import styles from "./styles.module.scss";

interface IProductQuantityDropdown {
  item: IOrderedItemView;
  hideDelete?: boolean;
  isWishlistCard?: boolean,
}

function ProductQuantityDropdown(props: IProductQuantityDropdown) {
  const {
    item, handleUpdateItem, hideDelete = false, newDropdown = false, isWishlistCard = false,
  } = props;

  const {
    availableQuantity = 0, quantity, core, sku,
  } = item;
  const [isLocalChange, setIsLocalChange] = useState(false);
  const [itemsQuantity, setItemsQuantity] = useState();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("common");

  const qtyArray = Array.from({ length: 9 }, (_, i) => i + 1).map((el) => ({ label: el, value: el }));
  const qtyOptions = [...qtyArray, { label: "10+", value: "10+" }];

  useEffect(() => {
    setItemsQuantity(quantity);
    setIsLocalChange(quantity >= 10);
  }, [quantity]);

  function onSelectItemQty(eventKey: any) {
    if (eventKey === "10+") {
      setIsLocalChange(true);
      setItemsQuantity(10);
    } else {
      updateItem(eventKey);
    }
  }

  function updateItem(number: any) {
    const updatedQuant = typeof number === "number" ? number : handleQuantity(itemsQuantity);

    handleUpdateItem(item, updatedQuant, () => {
      setItemsQuantity(availableQuantity);
    });
  }

  function handleQuantity(newQuant: any) {
    let newQuantity = 1;
    try {
      if (!isNaN(newQuant) && newQuant !== "") {
        newQuantity = parseInt(newQuant, 10);
        newQuantity = newQuantity < 1 ? 1 : newQuantity;
      }
    } catch (__err) {
      newQuantity = 1;
    }
    return newQuantity;
  }

  if (core) {
    return <span />;
  }
  if (!isLocalChange && quantity < 10) {
    if (newDropdown) {
      return (
        <SelectDropdown
          label={t("Quantity")}
          options={qtyOptions}
          handleChange={(option) => onSelectItemQty(option.value)}
          selectValue={item.quantity}
          isDisabled={isWishlistCard}
        />
      );
    }
    return (

      <DropdownButton
        open={open}
        disabled={!handleUpdateItem}
        data-testid="quantity-dropdown"
        bsStyle="default"
        className={`dropdown-quantity ${styles.quantity_button}`}
        title={`${t("Qty")}: ${quantity}`}
        id="quantity"
        onSelect={(eventKey: any) => onSelectItemQty(eventKey)}
        onToggle={() => {
          // handle update check is needed so that dropdown does not toggle when disabled
          // https://partsavatar.sentry.io/issues/5352662569/?project=1187556&referrer=issue-stream&statsPeriod=14d&stream_index=18
          if (handleUpdateItem) {
            setOpen(!open);
          }
        }}
      >
        {!hideDelete && <MenuItem eventKey={0} menuClassName="menuitem">{`${0 } (${ t("Delete this item") })`}</MenuItem> }
        {!hideDelete && <MenuItem divider menuClassName="menuitem" /> }
        {
          Array(Math.min(9, availableQuantity))
            .fill()
            .map((_, i) => (
              <MenuItem eventKey={i + 1} key={i + 1} menuClassName="menuitem">{i + 1}</MenuItem>
            ))
        }
        {availableQuantity > 10 && [
          <MenuItem key="divider" divider menuClassName="menuitem" />,
          <MenuItem key="10+" eventKey="10+" menuClassName="menuitem">10+</MenuItem>,
        ]}

      </DropdownButton>
    );
  }
  return (
    <div className="d-flex flex-column align-items-center">
      <label htmlFor={`quantity-input-${sku}`} className="hidden m-0" />
      <input
        data-testid="quantity-input"
        id={`quantity-input-${sku}`}
        type="number"
        onChange={(e) => setItemsQuantity(e.target.value)}
        value={itemsQuantity}
        className={`form-control text-center item-quantity ${styles.quantity_input}`}
        min="0"
        style={{
          width: "calc(5 * var(--safari-root-font, 10px))",
          height: "calc(3 * var(--safari-root-font, 10px))",
        }}
        disabled={isWishlistCard}
      />

      <PAButton
        disabled={!handleUpdateItem}
        style={{ width: 86, height: 25 }}
        onClick={updateItem}
        className="d-flex align-items-center m-t-5"
      >

        <span className="fa fa-refresh p-r-10" />
        {`${t("Update")}`}
      </PAButton>
    </div>
  );
}

export default ProductQuantityDropdown;
